import { observable, action } from "mobx";
import { makeApi, URLS } from "Utils/apiURL";

const defaultContactAccountUpdateObj = {
  contactCount: 0,
  contactIds: [],
  allContactsSelectedInView: false
};

class ContactAccountUpdateState {
  @observable showChangeAccountPopup = false;
  @observable contactAccountUpdateObj = { ...defaultContactAccountUpdateObj };

  @action
  setShowChangeAccountPopup = (val = false) => {
    this.showChangeAccountPopup = val;
  };

  @action
  setContactAccountUpdateObj = (obj = {}) => {
    this.contactAccountUpdateObj = obj;
  };

  @action
  resetContactAccountUpdateObj = () => {
    this.contactAccountUpdateObj = { ...defaultContactAccountUpdateObj };
  };

  @action
  changeContactsAccount = async (
    targetAccountId = "",
    contactIds = [],
    allContactsSelectedInView = false,
    totalCount = 0
  ) => {
    const config = {
      url: URLS.performContactsBulkOperation,
      method: "POST",
      data: {
        source: "CONTACT",
        type: "CONTACT_ACCOUNT_UPDATE",
        totalCount,
        filter: {
          ...(allContactsSelectedInView ? {} : { contactIds })
        },
        data: {
          targetAccountId
        }
      }
    };
    return await makeApi(config);
  };
}

const contactAccountUpdateState = new ContactAccountUpdateState();
export { contactAccountUpdateState };
